export default __webpack_public_path__ + "static/media/paris-paradise.9595b0b2.mp3";